<div class="modal-header">
	<h5 class="modal-title">Edit Description</h5>
	<button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
	<form [formGroup]="form" class="body">
		<app-textarea-control
			[resizable]="true"
			[height100]="false"
			[heightPx]="150"
			name="description"
			[formGroup]="form"
			label="Description"
			placeholder="Description"
		></app-textarea-control>
	</form>
</div>
<div class="modal-footer">
	<button
		type="button"
		[disabled]="form.invalid || form.pristine"
		class="btn btn-sm btn-primary btn-width"
		(click)="save()"
		data-id="submit"
	>
		Save
	</button>
</div>
